const VideoChevronLeftIcon = ({ size = "20", color = "#374151" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M14.1443 19.812C14.2978 19.6718 14.3744 19.48 14.3744 19.2875C14.3744 19.1138 14.3117 18.9401 14.1847 18.8027L6.10065 10.0038L14.1849 1.19904C14.4527 0.908866 14.436 0.456197 14.1445 0.189685C13.8543 -0.078166 13.4039 -0.0600414 13.1361 0.229443L4.56543 9.51496C4.31152 9.78977 4.31152 10.2096 4.56543 10.4846L13.1361 19.7701C13.4051 20.0576 13.8541 20.0799 14.1443 19.812Z"
      fill={color}
    />
  </svg>
);
export default VideoChevronLeftIcon;
